import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import OutlineCache from '@/utils/OutlineCache.js';
import BoxServiceCard from '@/views/study/components/box-service-card.vue';
import BoxGuideMain from '@/views/study/components/guide/box-guide-main.vue';
import BoxMainServiceTable from '@/views/study/components/box-main-service-table.vue';
import StudyGuide from '@/views/study/components/guide/study-guide.vue';
import { getOutlineContentTask, getOutLineProgress } from '@/api/modules/study.js'; // import BoxMainServiceSubmit from '@/views/study/components/box-main-service-submit.vue'

import BoxServiceStatus from '@/views/study/components/box-service-status.vue';
import BoxMainProgress from '@/views/study/components/box-main-progress.vue';
var cache = OutlineCache.getInstance();
export default {
  name: 'BoxCustomService',
  components: {
    BoxServiceCard: BoxServiceCard,
    BoxMainServiceTable: BoxMainServiceTable,
    BoxGuideMain: BoxGuideMain,
    StudyGuide: StudyGuide,
    BoxServiceStatus: BoxServiceStatus,
    BoxMainProgress: BoxMainProgress
  },
  props: {
    boxId: {
      type: [String, Number],
      default: ''
    },
    selectNode: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    subjectCode: {
      type: Number,
      default: 0
    },
    boxInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      service: {},
      // 专属服务
      schedule: null,
      // 学习进度
      params: {},
      unlockReviewCardCount: 0,
      // 已解锁复习卡片数量
      leafNode: null,
      edu: JSON.parse(localStorage.getItem('userInfo')).edu,
      expandNodes: [],
      serviceTagInfo: {
        persentage: 0,
        lockStatus: 1
      },
      serviceProgress: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['closeCodeDialog'])), {}, {
    emptyImg: function emptyImg() {
      return this.$resource('ucan_img_empty2.png');
    }
  }),
  watch: {
    selectNode: function selectNode() {
      if (!this.subjectCode) return;
      this.getOutlineContent();
    },
    subjectCode: function subjectCode() {
      if (!this.subjectCode) return;
      this.getOutlineContent();
    },
    closeCodeDialog: function closeCodeDialog(val) {
      val && this.getOutlineContent(); // 关闭弹窗刷新数据
    }
  },
  methods: {
    getOutlineContent: function getOutlineContent() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$selectNode, outLineId, virtualId, outLineType, type, _yield$getOutlineCont, status, data, _yield$getOutLineProg, s1, d1;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.selectNode) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", false);

              case 2:
                _this$selectNode = _this.selectNode, outLineId = _this$selectNode.outLineId, virtualId = _this$selectNode.virtualId, outLineType = _this$selectNode.outLineType, type = _this$selectNode.type;

                if (!(!outLineId && !virtualId)) {
                  _context.next = 7;
                  break;
                }

                _this.service = {};
                _this.schedule = {};
                return _context.abrupt("return");

              case 7:
                // 如果是关，说明此时是关服务
                _this.params = {
                  outlineId: outLineId || virtualId,
                  subjectId: _this.subjectCode,
                  virtualNodeType: outLineType === 1 ? '6' : type || (outLineType === 2 ? '5' : '0'),
                  // 虚拟节点类型 章的虚拟节点传6
                  edu: _this.edu
                };
                _context.next = 10;
                return getOutlineContentTask(_this.params);

              case 10:
                _yield$getOutlineCont = _context.sent;
                status = _yield$getOutlineCont.status;
                data = _yield$getOutlineCont.data;

                if (!(status !== 1)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                _this.service = data === null || data === void 0 ? void 0 : data.exclusiveService;
                _this.leafNode = !!(data !== null && data !== void 0 && data.leafNode);
                _this.schedule = data !== null && data !== void 0 && data.leafNode ? data === null || data === void 0 ? void 0 : data.leafNodeSchedule : data === null || data === void 0 ? void 0 : data.noLeafNodeSchedule;
                _this.unlockReviewCardCount = data === null || data === void 0 ? void 0 : data.unlockReviewCardCount; // 获取服务项标题栏解锁状态以及掌握程度

                _this.serviceTagInfo.persentage = data === null || data === void 0 ? void 0 : data.persentage;
                _this.serviceTagInfo.lockStatus = data === null || data === void 0 ? void 0 : data.lockStatus; // 获取本关服务/本章服务学习进度接口

                if (!(type === 1 || type === 2)) {
                  _context.next = 31;
                  break;
                }

                _context.next = 24;
                return getOutLineProgress({
                  outlineId: outLineId || virtualId,
                  virtualNodeType: type
                });

              case 24:
                _yield$getOutLineProg = _context.sent;
                s1 = _yield$getOutLineProg.status;
                d1 = _yield$getOutLineProg.data;

                if (!(s1 !== 1)) {
                  _context.next = 29;
                  break;
                }

                return _context.abrupt("return");

              case 29:
                _this.serviceProgress = d1; // 获取书本学习进度 展开的关节点

                _this.expandNodes = cache.getProgressOpenNodes(_this.edu, _this.subjectCode, _this.boxId) || [];

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};